import * as yup from 'yup';

export const ENDPOINT_URL_INVALID_ERROR = 'Enter a valid URL';
export const ENDPOINT_URL_PROTOCOL_ERROR = 'Only https protocol is supported';

export const isParseableUrl = (value: string): boolean => {
  try {
    return Boolean(new URL(value.trim()));
  } catch {
    return false;
  }
};

export const isHttpsUrl = (value: string): boolean => {
  try {
    return new URL(value.trim()).protocol === 'https:';
  } catch {
    return false;
  }
};

export const endpointUrlValidation = () =>
  yup
    .string()
    .transform((value) => value?.trim())
    .label('Endpoint URL')
    .test('is-url', ENDPOINT_URL_INVALID_ERROR, (value) =>
      !value || value.trim() === '' ? true : isParseableUrl(value)
    )
    .test('is-https', ENDPOINT_URL_PROTOCOL_ERROR, (value) =>
      !value || value.trim() === '' || !isParseableUrl(value)
        ? true
        : isHttpsUrl(value)
    );
